export enum ApplicationRole {
  ADMIN = 'ADMIN',
  DEVELOPER = 'DEVELOPER',
  LIBRARY_ADMIN = 'LIBRARY_ADMIN',
  GUEST = 'GUEST',
}

export enum BusinessRole {
  MEMBER = 'MEMBER',
  ENTRYPOINT_EMPLOYEE = 'ENTRYPOINT_EMPLOYEE',
  ENTRYPOINT_ADMIN = 'ENTRYPOINT_ADMIN',
  BROKER_EMPLOYEE = 'BROKER_EMPLOYEE',
  BROKER_COMPANY = 'BROKER_COMPANY',
  INSURANCE_EMPLOYEE = 'INSURANCE_EMPLOYEE',
  INSURANCE_COMPANY = 'INSURANCE_COMPANY',
  REDUCED_ADMIN = 'REDUCED_ADMIN',
}

export enum RoleType {
  INSURER = 'INSURER',
  BROKER = 'BROKER',
}
